window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      const getUrlParameter = (parameterName) => {
        const queryParametersStringPairs = window.location.search.substring(1).split('&');

        for (let i = 0; i < queryParametersStringPairs.length; i++) {
          const [key, value] = queryParametersStringPairs[i].split('=');

          if (parameterName === key) {
            return value[1] === undefined ? true : decodeURIComponent(value);
          }
        }

        return false;
      };

      const spinningLoader = () => {
        document
          .querySelector('.cpap__customer-personal-information__marketing-email-loading-container')
          .classList.add(
            'cpap__customer-personal-information__marketing-email-loading-container--active'
          );

        setTimeout(() => {
          document
            .querySelector(
              '.cpap__customer-personal-information__marketing-email-loading-container'
            )
            .classList.remove(
              'cpap__customer-personal-information__marketing-email-loading-container--active'
            );

          const url = new URL(window.location.href);
          url.searchParams.set('reloadTime', Date.now().toString());
          window.location.href = url.toString();
        }, 15000);
      };

      const passwordResetParameterValue = getUrlParameter('password-reset');

      if (passwordResetParameterValue === 'true') {
        document
          .querySelector('.cpap__customer-personal-information__request-sent-notification')
          .classList.add(
            'cpap__customer-personal-information__request-sent-notification--is-visible'
          );
      }

      document
        .querySelector('.cpap__customer-personal-information__request-sent-notification button')
        .addEventListener('click', () => {
          document
            .querySelector('.cpap__customer-personal-information__request-sent-notification')
            .classList.remove(
              'cpap__customer-personal-information__request-sent-notification--is-visible'
            );

          if (history.pushState) {
            const newHistoryPath =
              window.location.protocol +
              '//' +
              window.location.host +
              window.location.pathname +
              '';

            window.history.pushState({ path: newHistoryPath }, '', newHistoryPath);
          }
        });

      document.querySelector('#marketing-email-checkbox').addEventListener('click', (event) => {
        if (event.currentTarget.checked) {
          fetch('https://manage.kmail-lists.com/subscriptions/subscribe?a=UnFfF4&g=T9uBSk', {
            headers: {
              accept: '*/*',
              'accept-language': 'en-US,en;q=0.9',
              'content-type':
                'multipart/form-data; boundary=----WebKitFormBoundaryo1PaBT4imXeVR5GS',
            },
            body: `------WebKitFormBoundaryo1PaBT4imXeVR5GS\r\nContent-Disposition: form-data; name="$email"\r\n\r\n${window.cpap.customerPersonalInformation?.customerEmail}\r\n------WebKitFormBoundaryo1PaBT4imXeVR5GS--\r\n`,
            method: 'POST',
          }).catch((error) => {
            window.cpap.logError(error, {
              sentry__additionalData: {
                'Attempted Action': 'Subscribing to marketing email',
              },
              ga__errorMessagePrefix: 'Error subscribing to marketing email: ',
            });
          });

          spinningLoader();
        } else {
          fetch('https://manage.kmail-lists.com/subscriptions/unsubscribe?a=UnFfF4&g=T9uBSk', {
            headers: {
              accept: '*/*',
              'accept-language': 'en-US,en;q=0.9',
              'content-type':
                'multipart/form-data; boundary=----WebKitFormBoundaryt0PNUAa4bRJ77sZu',
            },
            referrer: 'https://manage.kmail-lists.com/subscriptions/unsubscribe?a=UnFfF4&g=T9uBSk',
            body: `------WebKitFormBoundaryt0PNUAa4bRJ77sZu\r\nContent-Disposition: form-data; name="$email"\r\n\r\n${window.cpap.customerPersonalInformation?.customerEmail}\r\n------WebKitFormBoundaryt0PNUAa4bRJ77sZu--\r\n`,
            method: 'POST',
          }).catch((error) => {
            window.cpap.logError(error, {
              sentry__additionalData: {
                'Attempted Action': 'Subscribing to marketing email',
              },
              ga__errorMessagePrefix: 'Error subscribing to marketing email: ',
            });
          });

          spinningLoader();
        }
      });
    },
    { priority: 'user-blocking' }
  );
});
